module.exports = __webpack_public_path__ + "assets/img/12_46_big.a13e4816.jpg";